import { render, staticRenderFns } from "./deposit_manage.vue?vue&type=template&id=4b9ae482"
import script from "./deposit_manage.vue?vue&type=script&lang=js"
export * from "./deposit_manage.vue?vue&type=script&lang=js"
import style0 from "./deposit_manage.vue?vue&type=style&index=0&id=4b9ae482&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports